import SectionHeading from "@/components/base/SectionHeading";
import { timelineItems } from "@/mocks/home";

const dotColor: Record<string, string> = {
  spread: "bg-secondary-400",
  doubt: "bg-accent-500",
  verdict: "bg-primary-500",
  clear: "bg-accent-600",
};

const legend = [
  { label: "开始扩散", color: "bg-secondary-400" },
  { label: "出现疑点", color: "bg-accent-500" },
  { label: "出具结论", color: "bg-primary-500" },
  { label: "对照辟谣", color: "bg-accent-600" },
];

export default function Timeline() {
  return (
    <section id="timeline" className="relative w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="TRACK RECORD"
        title="一张照片的辟谣对照时间线"
        desc="从首次扩散到出具结论，每一步都留下记录，还原争议照片是怎样被核实或辟谣的。"
      />

      <div className="flex flex-wrap gap-3 md:gap-5 mb-9">
        {legend.map((item) => (
          <div key={item.label} className="flex items-center gap-2">
            <span className={`w-2.5 h-2.5 rounded-full ${item.color}`}></span>
            <span className="font-label text-xs text-foreground-600">{item.label}</span>
          </div>
        ))}
      </div>

      <div className="relative">
        <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
        <ol className="space-y-6">
          {timelineItems.map((item, idx) => (
            <li key={`${item.date}-${idx}`} className="relative flex gap-5 md:gap-7">
              <span
                className={`relative z-10 shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full ${
                  dotColor[item.type] ?? "bg-secondary-400"
                } flex items-center justify-center ring-4 ring-background-100`}
              >
                <i className="ri-map-pin-2-fill text-background-50 text-xs md:text-sm"></i>
              </span>
              <div className="flex-1 rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-heading font-black text-sm text-primary-600">
                    {item.date}
                  </span>
                  <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950">
                    {item.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mt-2">
                  {item.desc}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}